RegistrationNewCtrl = ($scope, $routeParams, $filter, $translate, $location, flash, RegistrationService, AuthService, TermService) ->
  return $location.path('/') if AuthService.isSignedIn()
  # return $location.path('/term') unless TermService.isAccepted()

  $scope.isSubmitting = false
  $scope.account =
    gender: 'male'
    email_newsletter: true
  $scope.passwordPattern = /^(?=.{10,}$)((?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*\d))|(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]))|(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~])))[A-Za-z\d!"#$%&'()*+,\-\.\ /:;<=>?@\[\\\]^_`{|}~]+$/

  $scope.account.token = ''
  $scope.isLoading = true
  $(document).ready( ->
    token = $routeParams.token
    RegistrationService.check_token(token).then (resp) ->
      $scope.account.token = resp.data.token
      $('.crop-image-modal').modal 'hide'
    .catch (resp) ->
      if resp.data?.code is 'error.token_expired'
        $('.crop-image-modal').modal 'show'
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isLoading = false
  )

  $scope.closeModal = () ->
    $('.crop-image-modal').modal 'hide'
    window.location =  '/'
    return

  $scope.defaultData = RegistrationService.getDefaultData()

  $scope.translateData =
    password:
      minlength:
        subject: $filter('translate')('_REGISTRATION.NEW.PASSWORD')
        n: 10
      maxlength:
        subject: $filter('translate')('_REGISTRATION.NEW.PASSWORD')
        n: 32

  $scope.submit = (account) ->
    $scope.isSubmitting = true
    RegistrationService.create(account).then (resp) ->
      AuthService.signInBypass()
      TermService.clearAcceptLocal()
      $location.path '/'
    .catch (resp) ->
      if resp.data?.code is 'error.token_expired'
        $('.crop-image-modal').modal 'show'
      else if resp.data?.code is 'error.email_already_taken'
        flash.error $filter('translate')('EMAIL_DUPLICATED')
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitting = false

RegistrationNewCtrl.$inject = [
  '$scope'
  '$routeParams'
  '$filter'
  '$translate'
  '$location'
  'flash'
  'RegistrationService'
  'AuthService'
  'TermService'
]

module.exports = RegistrationNewCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/new-controller.coffee